import { getFaqList } from '@/apis/faq-list';
import { FAQ } from '../mutation-types';

export const state = {
  faqList: {},
};
export const getters = {
  faqList: state => state.faqList,
};
export const mutations = {
  [FAQ.GET_FAQ_LIST](state, data) {
    if (!data.error) {
      state.faqList = data;
    }
  },
};

export const actions = {
  async getFaqList({ commit }) {
    const res = await getFaqList();
    commit(FAQ.GET_FAQ_LIST, res);
    if (res.error) {
      return {
        error: true,
        messages: res?.error?.response?.data?.errors
      };
    }

    return { error: false };
  },
};
